import type { FormInstance } from 'antd';
import type { TFunction } from 'i18next';

type MessageApi = { error: (content: string) => void };

export function applySupplierSaveError(
  error: any,
  form: FormInstance,
  t: TFunction,
  message: MessageApi,
  fallbackMessage: string
): void {
  const responseData = error?.response?.data;

  if (responseData?.code === 'DUPLICATE_SUPPLIER_TAX_ID') {
    form.setFields([
      {
        name: 'taxId',
        errors: [
          t('suppliers:messages.taxIdExists', {
            name: responseData.existingSupplierName || t('suppliers:messages.existingSupplierFallback')
          })
        ]
      }
    ]);
  } else {
    message.error(responseData?.message || responseData?.error || fallbackMessage);
  }
}
